var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4299_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.85 50.0004C99.85 22.469 77.5314 0.150391 50 0.150391C22.4686 0.150391 0.150024 22.469 0.150024 50.0004C0.150024 77.5318 22.4686 99.8504 50 99.8504C77.5314 99.8504 99.85 77.5318 99.85 50.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 26H26V74H74V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 50.9258C52.8443 50.9258 55.6217 49.2 57.8207 46.0662C59.7614 43.3008 60.9199 39.8816 60.9199 36.9199C60.92 30.8987 56.0212 26 50 26C43.9788 26 39.0801 30.8987 39.0801 36.9199C39.0801 39.8816 40.2386 43.3008 42.1792 46.0662C44.3782 49.2 47.1557 50.9258 50 50.9258Z",
    fill: "#E334FF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0016 55.81C64.0775 52.8239 61.3689 50.4403 58.1683 48.9167C57.8283 48.7549 57.4235 48.8243 57.1568 49.0901C55.0116 51.2294 52.5367 52.36 49.9995 52.36C47.4619 52.36 44.9873 51.2294 42.8434 49.0903C42.5768 48.8242 42.1717 48.7547 41.8319 48.9166C38.6312 50.4402 35.9223 52.8239 33.998 55.8098C32.0213 58.8769 30.9766 62.4354 30.9766 66.1003V66.1158C30.9766 66.3669 31.0827 66.6065 31.2687 66.7753C36.406 71.4343 43.058 74.0001 49.9994 74.0001C56.9407 74.0001 63.5926 71.4343 68.73 66.7753C68.916 66.6065 69.0221 66.3671 69.0221 66.1158V66.1003C69.0224 62.4354 67.9779 58.8769 66.0016 55.81Z",
    fill: "#E334FF",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85 50.0004C99.85 22.469 77.5314 0.150391 50 0.150391C22.4686 0.150391 0.150024 22.469 0.150024 50.0004C0.150024 77.5318 22.4686 99.8504 50 99.8504C77.5314 99.8504 99.85 77.5318 99.85 50.0004Z",
    stroke: "#C1C9B6",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4299_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoProfile);
export default __webpack_public_path__ + "static/media/Photo_profile.bf42e80af7ff95c50e4e1e78c0d9763b.svg";
export { ForwardRef as ReactComponent };